// extracted by mini-css-extract-plugin
module.exports = {"mimic":"Mimic_mimic__1SaFo","content":"Mimic_content__1vSkx","ghostButton":"Mimic_ghostButton__3rdnX"};